import React, { Component, ErrorInfo, ReactNode } from "react";
import { Button, Typography } from "@mui/material";
import { Box } from "@mui/system";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  errorInfo?: Error;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    errorInfo: undefined,
  };

  public static getDerivedStateFromError(_: Error): State {
    // Update state so the next render will show the fallback UI.

    return { hasError: true, errorInfo: _ };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("Uncaught error:", error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            p: 10,
            flexDirection: "column",
          }}
        >
          <Typography fontSize={200} color={"error"}>
            500
          </Typography>
          <Typography fontWeight={500}>
            Có vẻ như có vài vấn đề khi chúng tôi đang cố gắng truy cập dữ liệu
          </Typography>
          <Box sx={{ p: 5 }}>
            <Button
              onClick={() => (window.location.href = "/")}
              variant="contained"
            >
              Thử lại
            </Button>
          </Box>
        </Box>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
